<template>
	<div class="change-password-component">
		<div class="change-password-component__content">
			<h4 class="header">Meagur</h4>
			<p class="instructions">Please fill out the form below to change your password.</p>
			<div class="change-password-form">
				<form @submit.prevent="thisChangePassword">
					<div class="form-group">
						<input type="password" class="text-input font-size--medium" placeholder="Current Password" v-model="currentPassword" required id="currentPassword">
						<i class="material-icons show-icon" @click="toggleCurrentPasswordVisible" v-if="showCurrentVisible">visibility_off</i>
						<i class="material-icons show-icon" @click="toggleCurrentPasswordVisible" v-else>visibility</i>
						<div class="requirements" v-if="showCurrentPasswordIncorrect">
							<ul>
								<li>That password is incorrect</li>
							</ul>
						</div>
					</div>
					<div class="form-group">
						<input class="text-input font-size--medium" type="password" placeholder="New Password" v-model="newPassword" required id="newPassword">
						<i class="material-icons show-icon" @click="toggleNewPasswordVisible" v-if="showNewVisible">visibility_off</i>
						<i class="material-icons show-icon" @click="toggleNewPasswordVisible" v-else>visibility</i>
						<div class="requirements" v-if="passwordInvalid">
							<ul>
								<li>Minimum of 8 characters</li>
							</ul>
						</div>
					</div>
					<div class="form-group">
						<input class="btn btn--form-submit font-size--medium" type="submit" value="Change Password">
					</div>
				</form>
			</div>

			<i class="material-icons md-36 close-button" @click="SET_CHANGE_PASSWORD(false)">close</i>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapActions } from 'vuex'

	export default {
		data() {
			return {
				currentPassword: '',
				newPassword: '',
				showCurrentPasswordIncorrect: false,
				showCurrentVisible: false,
				showNewVisible: false,
			}
		},
		computed: {
			passwordInvalid() {
				if (this.newPassword.length > 0 && this.newPassword.length < 8) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			...mapMutations([
				'SET_CHANGE_PASSWORD',
				'HTTP_FINISHED'
			]),
			...mapActions([
				'changePassword'
			]),
			thisChangePassword() {
				if(this.passwordInvalid) {
					return
				}
				this.changePassword({ current_password: this.currentPassword, updated_password: this.newPassword, updated_password_confirmation: this.newPassword })
					.then(() => {
						this.SET_CHANGE_PASSWORD(false)
						this.HTTP_FINISHED()
					}).catch(error => {
						if(error.response.data.code == 410) {
							this.showCurrentPasswordIncorrect = true
							this.currentPassword = ''
							this.newPassword = ''
							this.HTTP_FINISHED()
						}
					})
			},
			toggleCurrentPasswordVisible() {
				if(document.getElementById('currentPassword').type == 'password') {
					document.getElementById('currentPassword').type = 'text'
					this.showCurrentVisible = true
				} else {
					document.getElementById('currentPassword').type = 'password'
					this.showCurrentVisible = false
				}
			},
			toggleNewPasswordVisible() {
				if(document.getElementById('newPassword').type == 'password') {
					document.getElementById('newPassword').type = 'text'
					this.showNewVisible = true
				} else {
					document.getElementById('newPassword').type = 'password'
					this.showNewVisible = false
				}
			}
		},
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../styles/components/auth/changePassword'
</style>